class ProviderModalityController {
  /* @ngInject */
  constructor($log, $rootScope, $scope, Users, Auth, toastr, ngDialog) {
    Object.assign(this, {
      $rootScope,
      $log,
      Users,
      Auth,
      ngDialog,
      toastr,
      providermodalities: [],
      isStaffManager: false
    });
    this.getProviderModalities();
    this.staffManagerCheck();
  }

  staffManagerCheck() {
    let roles = this.Auth.profile.roles;
    this.isStaffManager = Object.values(roles).includes("staff manager");
  }

  getProviderModalities() {
    this.Users.getAllProviderModalities().then(({
      data
    }) => {
      this.providermodalities = data;
    }).catch(err => {
      console.log(err);
      this.toastr.error(`Error getting Provider Modality: ` + err.data.message.summary);
    });
  }

  updateProviderModality(row, value, modality) {
    // set up payload to be passed to backend
    payload = {
      slv: row.slv,
      async_and_phone: row.async_and_phone,
      async: row.async
    }; // change value of provider if passed in from angular

    if (modality in payload) {
      payload[modality] = value;
    } // send PUT request 


    this.Users.updateProviderModality(row.user_id, payload).then(response => {
      this.toastr.success('Provider modality updated successfully');
      this.getProviderModalities();
    }).catch(err => {
      console.log("Provider modality unable to be updated", err);
    });
  }

}

ProviderModalityController.$inject = ["$log", "$rootScope", "$scope", "Users", "Auth", "toastr", "ngDialog"];
angular.module('pims').controller('ProviderModalityController', ProviderModalityController);